namespace Serenity.EmailClient {

    export interface HtmlIFrameProps extends React.IframeHTMLAttributes<HTMLIFrameElement> {
        contents: string;
    }

    export class HtmlIFrame extends React.Component<HtmlIFrameProps> {
        private iframe: HTMLIFrameElement;

        updateContents() {
            var doc = this.iframe.contentDocument;
            doc.open();
            doc.write(this.props.contents || '');
            doc.close();
            var el = this.iframe;
            $(el.contentDocument.body).removeAttr('oncontextmenu');
            el.style.height = (Math.max(250, el.contentWindow.document.body.scrollHeight + 30)) + 'px';
        }

        componentDidMount() {
            this.updateContents();
        }

        componentWillReceiveProps(nextProps: HtmlIFrameProps) {
            if (nextProps.contents !== this.props.contents)
                this.updateContents();
        }

        render() {
            var { contents, ...other } = this.props;
            return (<iframe ref={el => this.iframe = el} {...other}></iframe>);
        }
    }
}